// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.question[data-v-556da294] {\r\n  font-size: 14px;\r\n  font-weight: bold;\n}\ninput[data-v-556da294] {\r\n  color: white !important;\n}\n.NPS[data-v-556da294] {\r\n  margin: 15px;\r\n  text-align: center;\r\n  background-color: #65bd60;\r\n  color: rgb(0, 0, 0);\r\n  font-size: 18px;\r\n  padding-top: 10px;\r\n  padding-bottom: 10px;\n}\r\n\r\n\r\n", ""]);
// Exports
module.exports = exports;
